<template>
  <div class="template-table">
    <el-table height="200" border ref="multipleTable" :data="tableDatas" tooltip-effect="dark" >
      <el-table-column
          :label="$translate('lang.E3202102250028', { defaultText: '产品模板编码' })"
          prop="templateCode"
          width="150"
          :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
          :label="$translate('lang.E3202102250024', { defaultText: '模板名称' })"
          prop="templateName"
          width="150"
          :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
          :label="$translate('lang.E3202102250029', { defaultText: '模板说明' })"
          prop="templateDescription"
          width="200"
          :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
          :label="$translate('lang.E3202102250025', { defaultText: '状态' })"
          sortable
          prop="status">
          <template slot-scope="scope">
            <span :style="{color:scope.row.status==='N'?'red':''}">
              {{scope.row.status=='Y'?$translate('lang.E3202102260004', { defaultText: '启用' }):$translate('lang.E3202102260003', { defaultText: '停用' })}}
            </span>
          </template>
      </el-table-column>
      <el-table-column
          :label="$translate('lang.E3202102250030', { defaultText: '创建来源' })"
          prop="source"
          :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
          :label="$translate('lang.E3202102250026', { defaultText: '创建人' })"
          prop="createUserName"
          :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
          :label="$translate('lang.E3202102250027', { defaultText: '创建时间' })"
          prop="createTime"
          sortable
          width="200"
          :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
          :label="$translate('lang.E3202102250031', { defaultText: '更新人' })"
          prop="updateUserName"
          :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
          :label="$translate('lang.E3202102250032', { defaultText: '更新时间' })"
          prop="updateTime"
          sortable
          width="200"
          :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
          :label="$translate('lang.E3202101250007', { defaultText: '操作' })"
          fixed="right"
          width="100">
          <template slot-scope="scope">
              <el-button type="text" @click="indexState(scope.row)">
                {{scope.row.status=='Y'?$translate('lang.E3202102260003', { defaultText: '停用' }):$translate('lang.E3202102260004', { defaultText: '启用' })}}
              </el-button>
              <el-button type="text" @click="gotoPublic(scope.row)">
                {{$translate('lang.E3202102260009', { defaultText: '编辑' })}}
              </el-button>
          </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
    props: ['tableData'],
    computed: {
        tableDatas() {
            return this.tableData;
        }
    },
    methods: {
        coding(row) {
            this.$emit('coding', row);
        },
        // 点击图标，去往公共属性页面
        gotoPublic(row) {
            this.$emit('gotoPublic', row);
        },
        // 获取状态
        indexState(row) {
            this.$emit('indexState', row);
        }
    }
};
</script>
<style lang="less">
.template-table{
   .el-table--border {
        border: 1px solid #EBEEF5;
    }
    .el-table__fixed-right{
        height: 100% !important;
    }
}

</style>